import { getDatabase, onValue, ref } from "firebase/database"
import { type ElementRef, useEffect, useMemo, useRef, useState } from "react"
import { useParams } from "react-router"

import app from "@/config/firebaseConfig"
import type { TicketReply } from "@/types/ticketTypes"

import TicketMessage from "./TicketMessage"
import style from "./TicketsStyle.module.css"

export default function TicketChatContainer({
  values,
  data,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values: any
  data?: Array<TicketReply>
}) {
  const chatContainerRef = useRef<ElementRef<"div">>(null)

  const { chatId } = useParams()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [messages, setMessages] = useState<any>([])

  useEffect(() => {
    const db = getDatabase(app)
    const messagesRef = ref(db, `tickets/${chatId}/messages`) // fallback لـ 14 لو chatId فاضي
    const unsubscribe = onValue(messagesRef, (snapshot) => {
      const data = snapshot.val()

      if (data) {
        const messagesArr = Object.entries(data).map(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          ([firebaseKey, value]: [string, any]) => ({
            ...value,
            id: firebaseKey,
          })
        )

        setMessages(messagesArr)
        console.log("Firebase messages updated:", messagesArr)
      } else {
        setMessages([])
        console.log("No messages for this ticket")
      }
    })

    return () => unsubscribe()
  }, [chatId])

  // TODO: check this
  const finalArr = useMemo(() => {
    if (!data) return []
    return values.audio !== "" ? [...data] : data
  }, [values, data])

  // Automatically scroll to the bottom when content changes
  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current?.scrollHeight
    }
  }, [finalArr]) // Trigger when the finalArr changes

  return (
    <div className={style["chat_con"]} ref={chatContainerRef}>
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      {messages.map((ele: any, index: number) => {
        return (
          <TicketMessage
            ele={ele}
            key={index}
            user={
              ele?.type === "admin" || ele?.type === "instructor"
                ? "user"
                : "agent"
            }
          />
        )
      })}
    </div>
  )
}
